import React from 'react';
import { useForm } from 'react-hook-form';
import FormWrapper from '../../../../../../Components/Form/FormWrapper';
import InputWrapper from '../../../../../../Components/Form/components/InputWrapper/InputWrapper';
import InputField from '../../../../../../Components/Form/components/InputField';
import SubmitButton from '../../../../../../Components/Button/SubmitButton';
import { FormValues } from '../../../../../MagicForm/Interfaces/FormValues';
import { InsuranceSettings } from '../../../../Interfaces/insuranceSettings';

interface Props {
	onSubmit: (values: InsuranceCompanyValues) => void;
	settings: InsuranceSettings | null;
}

export interface InsuranceCompanyValues extends FormValues {
	companyIdentificationNumber: string;
	username: string;
	password: string;
}

const InsuranceCompany: React.FC<Props> = ({ onSubmit, settings }) => {
	const formMethods = useForm({
		defaultValues: {
			companyIdentificationNumber: settings?.companyIdentificationNumber,
			username: settings?.username,
		},
	});

	const handleSubmit = (values: InsuranceCompanyValues) => {
		if (!values.password) {
			values.password = settings?.password || '';
		}

		onSubmit(values);
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<InputWrapper>
				<InputField name='companyIdentificationNumber' label='IČO' />
			</InputWrapper>
			<InputWrapper>
				<InputField name='username' label='Uživatelské jméno' />
			</InputWrapper>
			<InputWrapper>
				<InputField name='password' type='password' label='Heslo' />
			</InputWrapper>
			<InputWrapper>
				<SubmitButton
					onSubmit={handleSubmit}
					title={'component.nczi.setup.save'}
				/>
			</InputWrapper>
		</FormWrapper>
	);
};

export default InsuranceCompany;
